import { Hub } from 'aws-amplify';
import { useEffect } from 'react';

const PLANERA_AUTH_SYNC_KEY = 'planera.authSync'; // Unique key for localStorage to trigger storage events

// Amplify v5 emits events as signIn / signOut.
// Amplify v6 emits events as signedIn / signedOut.
// sadly they have only declared these as string so we have to do this.
const VALID_EVENTS = new Set(['signIn', 'signedIn', 'signOut', 'signedOut']);

const onHub = (capsule?: { payload?: { event?: string } }) => {
  const event = capsule?.payload?.event ?? '';
  if (!VALID_EVENTS.has(event)) return;
  try {
    localStorage.setItem(PLANERA_AUTH_SYNC_KEY, JSON.stringify({ action: event, timestamp: Date.now() }));
  } catch (error) {
    logger.error('Failed to write auth sync key to localStorage', {
      error: error,
      rum: {
        context: {
          feature: 'auth-sync',
          action: 'write-auth-sync-localstorage'
        }
      }
    });
  }
};

const onStorage = (event: StorageEvent) => {
  if (event.storageArea !== localStorage || event.key !== PLANERA_AUTH_SYNC_KEY || !event.newValue) return;
  window.location.reload();
};

export function useCrossTabAuthReload() {
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', onHub);
    window.addEventListener('storage', onStorage);

    return () => {
      unsubscribe();
      window.removeEventListener('storage', onStorage);
    };
  }, []);
}
